import type { DictionaryEntry } from "@/lib/types";
import { Card, CardContent } from "@/components/ui/card";
import { config } from "@/lib/config";
import { ClickableCharacters } from "./ClickableCharacters";

interface EntryCardProps {
  entry: DictionaryEntry;
  compact?: boolean;
  matchType?: "traditional" | "jyutping" | "english";
  onCharacterClick?: (character: string) => void;
}

const matchTypeLabels = {
  traditional: "Chinese",
  jyutping: config.pronunciationLabel,
  english: "English",
};

export function EntryCard({ entry, compact = false, matchType, onCharacterClick }: EntryCardProps) {
  if (compact) {
    return (
      <div className="py-2 border-b border-border last:border-b-0">
        <div className="flex items-baseline gap-3">
          <span className="text-2xl font-medium">
            <ClickableCharacters text={entry.traditional} onCharacterClick={onCharacterClick} />
          </span>
          <span className="text-sm text-blue-600 dark:text-blue-400 font-mono">
            {entry.jyutping}
          </span>
        </div>
        <div className="mt-1 text-sm text-muted-foreground">
          {entry.definitions.join("; ")}
        </div>
      </div>
    );
  }

  return (
    <Card className="overflow-hidden">
      <CardContent className="p-4">
        <div className="flex items-start justify-between gap-2">
          <div className="text-4xl font-medium mb-2">
            <ClickableCharacters text={entry.traditional} onCharacterClick={onCharacterClick} />
          </div>
          {matchType && (
            <span className="text-xs px-2 py-0.5 rounded bg-muted text-muted-foreground shrink-0">
              {matchTypeLabels[matchType]}
            </span>
          )}
        </div>
        <div className="text-lg text-blue-600 dark:text-blue-400 font-mono mb-3">
          {entry.jyutping}
        </div>
        <ul className="list-disc list-inside text-muted-foreground space-y-1">
          {entry.definitions.map((def, i) => (
            <li key={i} className="text-sm">
              {def}
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
}
